import React from "react";
import styles from "./styles.module.scss";
import { DemoSpaceTimelineModel } from "./indexModel";
import DemoSpaceFeedPostingForm from "../../../components/DemoSpaceFeedPostingForm";
import Filter from "./DemoFeedFilter";
import DemoSpacesTimeline from "./DemoSpacesTimeline";

const DemoSpaceTimeline = () => {
  const { selectedDemoSpace } = DemoSpaceTimelineModel();

  return (
    <>
      {selectedDemoSpace && (
        <div className={styles.content_container}>
          <DemoSpaceFeedPostingForm />
          <Filter />
          <DemoSpacesTimeline posts={selectedDemoSpace.posts} />
        </div>
      )}
    </>
  );
};

export default DemoSpaceTimeline;
